<h2 mat-dialog-title>{{ 'client.disability.type.delete.title' | transloco }}</h2>
<mat-dialog-content>
	<p>{{ 'client.disability.type.delete.confirmation' | transloco }}</p>
</mat-dialog-content>
<mat-dialog-actions class="actions-row">
	<lvr-button
		variant="secondary"
		[label]="'base.button.cancel' | transloco"
		[type]="'button'"
		mat-dialog-close
		icon="disabled_by_default"
	>
	</lvr-button>
	<lvr-button
		variant="primary"
		[label]="'base.button.delete' | transloco"
		[loadingLabel]="'base.button.deleting' | transloco"
		[loading]="loading()"
		[type]="'button'"
		(clicked)="deleteType()"
		icon="delete"
	>
	</lvr-button>
</mat-dialog-actions>
